<ng-template #modal let-hide="close">
  <div class="modal-header">
    <h4 i18n class="modal-title">My settings</h4>
    <my-global-icon iconName="cross" aria-label="Close" role="button" (click)="hide()"></my-global-icon>
  </div>

  <div class="modal-body">
    <div i18n class="mb-4 font-italic">These settings apply only to your session on this instance.</div>

    <div i18n class="mb-4 quick-settings-title">Display settings</div>

    <my-user-video-settings
      *ngIf="!isUserLoggedIn()"
      [user]="user" [userInformationLoaded]="userInformationLoaded" [reactiveUpdate]="true" [notifyOnUpdate]="true"
    >

      <ng-container ngProjectAs="inner-title">
        <div i18n class="mb-4 mt-4 quick-settings-title">Video settings</div>
      </ng-container>
    </my-user-video-settings>

    <div i18n class="mb-4 mt-4 quick-settings-title">Interface settings</div>

    <my-user-interface-settings
      *ngIf="!isUserLoggedIn()"
      [user]="user" [userInformationLoaded]="userInformationLoaded" [reactiveUpdate]="true" [notifyOnUpdate]="true"
    ></my-user-interface-settings>
  </div>
</ng-template>
